import COLORS from '../../utils/Colors';
import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    overflow: auto;
    text-align: justify;
    padding: 1.5rem;
    gap: 1rem;
    margin-bottom: 10%;
    background-color: ${COLORS.freshaWhite};
`;

export const DoubleCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    background-color: red;
`;

export const Title = styled.p`
    font-size: 1em;
    font-weight: bold;
    color: ${COLORS.black};
    margin-right: 1rem;
`;

export const Option = styled.p`
    font-size: 1em;
    color: ${COLORS.black};
`;

